<div class="min-h-screen flex flex-col bg-gray-50 pt-16">    <!-- Navbar -->
    <nav class="bg-indigo-600 shadow-lg fixed top-0 left-0 right-0 z-[9999]">
        <div class="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between h-16">
                <div class="flex"> <!-- Logo and hamburger menu -->
                    <div class="flex-shrink-0 flex items-center space-x-2">
                        <!-- Mobile menu button with animation -->
                        <button type="button"
                            class="md:hidden inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-indigo-700 focus:outline-none transition-all duration-300 ease-in-out"
                            (click)="toggleSidebar()" pRipple>
                            <span class="sr-only">{{sidebarVisible ? 'Close' : 'Open'}} sidebar</span>
                            <svg [class.rotate-90]="sidebarVisible"
                                class="h-6 w-6 transition-transform duration-300 ease-in-out"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        </button>

                        <!-- Desktop toggle sidebar button - always visible and with higher z-index -->
                        <button type="button"
                            class="hidden md:inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-indigo-700 focus:outline-none transition-all duration-300 ease-in-out desktop-toggle-btn"
                            (click)="toggleSidebar()" pRipple>
                            <span class="sr-only">{{sidebarVisible ? 'Collapse' : 'Expand'}} sidebar</span>
                            <svg class="h-6 w-6 transition-transform duration-300 ease-in-out"
                                [ngClass]="{'transform rotate-180': !sidebarVisible}" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                            </svg>
                        </button>

                        <!-- Logo -->
                        <span class="text-white text-xl font-semibold navbar-title">Notarial System</span>
                    </div>
                </div> <!-- Right side nav items -->
                <div class="flex items-center">
                    <div class="flex-shrink-0 notifications-container relative">
                        <button type="button"
                            class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-700 shadow-sm hover:bg-indigo-800 focus:outline-none"
                            (click)="toggleNotifications($event)" pRipple>
                            <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path
                                    d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                            </svg> <span>Notifications</span>
                        </button>
                        <!-- Badge for unread notifications - positioned outside the button -->
                        <span *ngIf="getUnreadCount() > 0"
                            class="notification-badge absolute -top-2 -right-2 flex items-center justify-center h-6 w-6 rounded-full bg-red-500 text-xs font-medium text-white">
                            {{getUnreadCount()}}
                        </span>
                        <!-- Notifications dropdown -->
                        <div *ngIf="isNotificationsOpen"
                            class="notifications-panel absolute right-0 mt-2 w-80 max-w-md rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                            role="menu">
                            <div class="py-2">
                                <div class="border-b border-gray-200">
                                    <div class="flex justify-between items-center px-4 py-2">
                                        <h3 class="text-lg font-medium text-gray-900">Notifications</h3>
                                        <button *ngIf="getUnreadCount() > 0" (click)="markAllAsRead()"
                                            class="text-xs text-indigo-600 hover:text-indigo-900 font-medium">
                                            Mark all as read
                                        </button>
                                    </div>
                                </div>

                                <!-- Scrollable notifications container -->
                                <div class="max-h-60 overflow-y-auto notifications-scrollable">
                                    <div *ngIf="notifications.length === 0" class="px-4 py-3 text-sm text-gray-700">
                                        No notifications
                                    </div>

                                    <div *ngFor="let notification of notifications"
                                        class="px-4 py-3 hover:bg-gray-50 transition-colors duration-150 ease-in-out border-b border-gray-100 last:border-b-0"
                                        [ngClass]="{'bg-indigo-50': !notification.read}">
                                        <div class="flex justify-between">
                                            <p class="text-sm font-medium"
                                                [ngClass]="{'text-gray-900': !notification.read, 'text-gray-600': notification.read}">
                                                {{notification.title}}
                                            </p>
                                            <button *ngIf="!notification.read" (click)="markAsRead(notification.id)"
                                                class="text-xs text-indigo-600 hover:text-indigo-800">
                                                Mark read
                                            </button>
                                        </div>
                                        <p class="text-xs text-gray-500 mt-1">{{notification.time}}</p>
                                        <p class="text-sm text-gray-600 mt-1">{{notification.content}}</p>
                                    </div>
                                </div>

                                <!-- View all link -->
                                <div class="border-t border-gray-100">
                                    <a routerLink="/home/notifications"
                                        class="block w-full text-center px-4 py-2 text-sm text-indigo-600 hover:bg-gray-50">
                                        View all notifications
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Profile dropdown -->
                    <div class="ml-3 relative user-menu-container">
                        <div>
                            <button type="button"
                                class="w-10 h-10 flex items-center justify-center rounded-full bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-700 focus:ring-white transition"
                                pRipple (click)="toggleUserMenu($event)">
                                <i class="pi pi-user text-white text-xl"></i>
                            </button>
                        </div>

                        <!-- User dropdown menu -->
                        <div *ngIf="isUserMenuOpen"
                            class="user-menu origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                            role="menu" [ngClass]="{'animate-dropdown': isUserMenuOpen}">
                            <a routerLink="/home/profile"
                                class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                role="menuitem">
                                <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                </svg>
                                Perfil
                            </a>
                            <div class="border-t border-gray-100"></div>
                            <button (click)="logout()"
                                class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                role="menuitem">
                                <svg class="mr-3 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                                </svg>
                                Cerrar Sesión
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>    </nav>    <div class="flex flex-1 overflow-hidden relative w-full">        
        <!-- Mobile overlay - full screen (only shown on mobile) -->
        <div *ngIf="sidebarVisible && isMobile" (click)="toggleSidebar()"
            class="md:hidden fixed inset-0 bg-gray-900 bg-opacity-75 z-50 transition-all duration-300 ease-in-out animate-fade-in">
        </div>
        
        <!-- Sidebar with enhanced transitions -->
        <aside [ngClass]="{
        'sidebar': true,
        'sidebar-visible': sidebarVisible,
        'sidebar-hidden': !sidebarVisible,
        'sidebar-transition': true,
        'mobile-sidebar': isMobile
      }" [ngStyle]="{'top': '4rem'}" class="fixed left-0 transform z-[9999] h-[calc(100vh-4rem)] overflow-hidden">
            <div class="flex flex-col w-64 bg-white shadow-lg h-full overflow-hidden" [ngClass]="{'animate-slide-in': sidebarVisible}">
                <!-- Close button for mobile -->
                <button (click)="toggleSidebar()"
                    class="md:hidden sidebar-close-btn p-2 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 transition-colors duration-200 absolute top-2 right-2"
                    pRipple>
                    <span class="sr-only">Close sidebar</span>
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto h-full">
                    <div class="flex items-center flex-shrink-0 px-4">
                        <h2 class="text-lg font-medium text-gray-900">Navigation</h2>
                    </div>                    <nav class="mt-5 flex-1 px-2 space-y-1">
                        <!-- Navigation Links -->
                        <!-- Dashboard - Single item -->
                        <a routerLink="/home/dashboard" routerLinkActive="bg-indigo-100 text-indigo-900"
                            [routerLinkActiveOptions]="{exact: true}"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                aria-hidden="true">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                            </svg>
                            Dashboard
                        </a>

                        <!-- Advanced Dashboard (Audit) - Single item -->
                        <!--
                        <a routerLink="/home/advanced-dashboard" routerLinkActive="bg-indigo-100 text-indigo-900"
                            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                            pRipple>
                            <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                            </svg>
                            Dashboard Avanzado
                        </a>
                        -->

                        <!-- Admin Panel - Tree Item with children -->
                        <div class="space-y-1" *appHasPermission="[PERMISSIONS.USER_READ, PERMISSIONS.ROLE_READ, PERMISSIONS.BANKACCOUNT_READ, PERMISSIONS.ADMIN_SYSTEM, PERMISSIONS.ADMIN_TENANT]">
                            <!-- Parent menu item -->
                            <button (click)="toggleSubmenu('admin')" 
                                class="group w-full flex items-center px-2 py-2 text-sm font-medium rounded-md text-gray-600 hover:bg-indigo-50 hover:text-indigo-900"
                                [ngClass]="{'bg-indigo-50 text-indigo-800': isSubmenuOpen('admin')}"
                                pRipple>
                                <svg class="text-gray-400 group-hover:text-indigo-500 mr-3 flex-shrink-0 h-6 w-6"
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" 
                                    stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <span class="flex-1 text-left">Admin Panel</span>
                                <!-- Arrow icon indicating expand/collapse -->
                                <svg class="ml-3 h-4 w-4 transform transition-transform duration-200"
                                    [ngClass]="{'rotate-90': isSubmenuOpen('admin')}"
                                    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd"
                                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                            
                            <!-- Admin Submenu items -->
                            <div *ngIf="isSubmenuOpen('admin')" class="transition-all duration-200 ease-in-out"
                                [@slideInOut]>
                                <a *appHasPermission="PERMISSIONS.USER_READ" routerLink="/home/users"
                                    routerLinkActive="bg-indigo-50 text-indigo-800"
                                    class="group flex items-center pl-10 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-indigo-50 hover:text-indigo-900"
                                    pRipple>
                                    <span>Gestión de Usuarios</span>
                                </a>
                                <!-- <a *appHasPermission="PERMISSIONS.ROLE_READ" routerLink="/home/roles"
                                    routerLinkActive="bg-indigo-50 text-indigo-800"
                                    class="group flex items-center pl-10 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-indigo-50 hover:text-indigo-900"
                                    pRipple>
                                    <span>Roles y Permisos</span>
                                </a> -->
                                <a *appHasPermission="PERMISSIONS.BANKACCOUNT_READ" routerLink="/home/admin/bank-accounts"
                                    routerLinkActive="bg-indigo-50 text-indigo-800"
                                    class="group flex items-center pl-10 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-indigo-50 hover:text-indigo-900"
                                    pRipple>
                                    <span>Cuentas Bancarias</span>
                                </a>
                                <a *appHasPermission="PERMISSIONS.DISPERSION_READ" routerLink="/home/admin/dispersion-rules"
                                    routerLinkActive="bg-indigo-50 text-indigo-800"
                                    class="group flex items-center pl-10 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-indigo-50 hover:text-indigo-900"
                                    pRipple>
                                    <span>Reglas de Dispersión</span>
                                </a>
                                <a *appHasPermission="PERMISSIONS.AUDIT_READ" routerLink="/home/admin/audit-logs"
                                    routerLinkActive="bg-indigo-50 text-indigo-800"
                                    class="group flex items-center pl-10 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:bg-indigo-50 hover:text-indigo-900"
                                    pRipple>
                                    <span>Logs y Auditoría</span>
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>
        </aside>

        <!-- Main content - Will be pushed by sidebar when it's open -->
        <div class="flex-1 overflow-auto focus:outline-none main-content w-full md:relative"
            [ngClass]="{'expanded-content': !sidebarVisible, 'sidebar-open': sidebarVisible}" tabindex="0">
            <main class="flex-1 relative z-0 overflow-y-auto w-full">
                <div class="w-full">
                    <!-- Router outlet for content - Sin padding para permitir que los componentes controlen su espacio -->
                    <router-outlet></router-outlet>
                </div>
            </main>
        </div>
    </div>
</div>